import type { ReactNode } from 'react';
import styled from 'styled-components';

import { laptopAndAbove } from 'style/mediaQuery';
import { theme } from 'style/theme';

type Props = {
  message: ReactNode;
  position: 'left' | 'right';
};

const Root = styled.div`
  z-index: ${theme.zIndex.tooltip};
  @media ${laptopAndAbove} {
    position: absolute;
    &.left {
      right: calc(100% + 20px);
    }
    &.right {
      left: calc(100% + 20px);
    }
    width: 220px;
    top: 0;
    margin: 0;
  }
`;
const Anchor = styled.div`
  z-index: ${theme.zIndex.tooltip};
  background-color: var(--c-yellow-400);
  height: 17px;
  width: 17px;
  flex-shrink: 0;
  flex-grow: 0;
  border-radius: 50%;
  display: none;
  position: absolute;
  top: 40px;
  @media ${laptopAndAbove} {
    display: initial;
  }
  &.left {
    left: -8px;
  }
  &.right {
    right: -8px;
  }
`;

const RootDiv = styled.div`
  background-color: white;
  border-radius: var(--unit);
  border: 1px solid var(--c-yellow-400);
`;

const ContainerDiv = styled.div`
  font-family: var(--sorare-font);
  font-weight: 400;
  font-style: normal;
  font-size: 15px;
  line-height: 22px;
  color: var(--c-black);
  border-radius: inherit;
  background-color: rgba(240, 206, 29, 0.25);
  padding: 10px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.05);
  text-align: left;
`;

export const OnboardingTooltip = (props: Props) => {
  const { message, position } = props;

  return (
    <>
      <Root className={position}>
        <RootDiv>
          <ContainerDiv>{message}</ContainerDiv>
        </RootDiv>
      </Root>
      <Anchor className={position} />
    </>
  );
};
